const placeData = [
    {
        id: '1',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (4).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '2',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (5).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '3',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (6).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '4',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (7).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '5',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151.png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '6',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (1).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '7',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (2).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '8',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (3).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '9',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (8).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '10',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (9).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '11',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (10).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '12',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (11).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '13',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (12).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '14',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (13).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '15',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (14).png',
        star: '/img/Frame 59528.svg'
    },
    {
        id: '16',
        title: 'Desert King',
        subTitle: '1MBT per night',
        km: '2345km away',
        days: 'available for 2weeks stay',
        img: '/img/Frame 151 (15).png',
        star: '/img/Frame 59528.svg'
    },
]

export default placeData